<template>
  <div>
    <div class="containerFull" style="min-height:600px">
      <div class="p-grid">
        <div class="p-col-12">
          <div class="containerHeader">
            <h2 class="p-pb-5 p-mt-6">
              Especialidades del medico {{ nombreMedico }}
            </h2>
            <Button
              label="Volver"
              icon="pi pi-arrow-circle-left"
              @click="$router.push({ name: 'usuarios_admin' })"
              name="volver"
            />
          </div>
          <DataTable
            ref="dt"
            :value="usuariosEspecialidades"
            dataKey="id"
            :paginator="true"
            :rows="10"
            :filters="filters"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25]"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} especialidades"
            class="p-datatable-responsive-demo p-mt-5"
            style="margin-bottom:100px"
            :loading="loading"
          >
            <template #header>
              <div
                class="table-header"
                style="align-items: center;display: flex;"
              >
                <Button
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-info p-mr-3"
                  @click="openNew"
                  :disabled="loading"
                  name="nuevo"
                />
                <span class="tituloUsuarios">Especialidades</span>
                <span class="p-input-icon-left" style="margin-left: auto;">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters['global']"
                    placeholder="Buscar..."
                  />
                </span>
              </div>
            </template>
            <Column field="nombre" header="Nombre" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Nombre</span>
                {{ slotProps.data.nombre }}
              </template>
            </Column>
            <Column field="fecha_grado" header="Fecha Grado" :sortable="true"
              ><template #body="slotProps">
                <span class="p-column-title">Fecha Grado</span>
                {{ slotProps.data.fecha_grado }}
              </template></Column
            >
            <Column
              field="universidad"
              header="Universidad"
              :sortable="true"
            ></Column>
            <Column field="titulo" header="Titulo" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Titulo</span>
                {{ slotProps.data.titulo }}
              </template>
            </Column>
            <Column field="descripcion" header="Comentarios" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Descripción</span>
                {{ slotProps.data.descripcion }}
              </template>
            </Column>
            <Column :exportable="false">
              <template #body="slotProps">
                <span class="p-column-title">Acciones</span>
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success p-mr-2"
                  @click="editUsuarioEspecialidad(slotProps.data)"
                  name="editar"
                />
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDeleteUsuarioEspecialidad(slotProps.data)"
                  name="eliminar"
                />
              </template>
            </Column>
          </DataTable>

          <Dialog
            :closable="false"
            :visible="usuarioEspecialidadDialog"
            :style="{ width: '450px' }"
            header="Detalles del Grado de la Especialidad"
            :modal="true"
            class="p-fluid"
            :contentStyle="{ overflow: 'visible' }"
          >
            <div class="p-grid">
              <div class="p-field p-col-12">
                <label for="id_especialidad">Especialidad</label>
                <Dropdown
                  v-model="usuarioEspecialidad.id_especialidad"
                  :options="especialidades"
                  optionLabel="nombre"
                  optionValue="id"
                  placeholder="Selecciona una especialidad"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      submitted && !usuarioEspecialidad.id_especialidad,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="submitted && !usuarioEspecialidad.id_especialidad"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="fecha_grado">Fecha del Grado</label>
                <Calendar
                  id="basic"
                  v-model="usuarioEspecialidad.fecha_grado"
                  :manualInput="false"
                  :locale="es"
                  dateFormat="dd/mm/yy"
                  :monthNavigator="true"
                  :yearNavigator="true"
                  yearRange="1900:2021"
                  required="true"
                  :class="{
                    'p-invalid': submitted && !usuarioEspecialidad.fecha_grado,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="submitted && !usuarioEspecialidad.fecha_grado"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="universidad">Universidad</label>
                <InputText
                  id="universidad"
                  v-model.trim="usuarioEspecialidad.universidad"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid': submitted && !usuarioEspecialidad.universidad,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="submitted && !usuarioEspecialidad.universidad"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="titulo">Titulo</label>
                <InputText
                  id="titulo"
                  v-model.trim="usuarioEspecialidad.titulo"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid': submitted && !usuarioEspecialidad.titulo,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="submitted && !usuarioEspecialidad.titulo"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="descripcion">Comentario</label>
                <InputText
                  id="descripcion"
                  v-model="usuarioEspecialidad.descripcion"
                  autofocus
                  maxlength="200"
                />
              </div>
            </div>
            <template #footer>
              <Button
                label="Cancelar"
                icon="pi pi-times"
                class="p-button-text"
                @click="hideDialog"
                name="cancelar"
              />
              <Button
                label="Guardar"
                icon="pi pi-check"
                class="p-button-text"
                @click="saveUsuarioEspecialidad"
                name="guardar"
              />
            </template>
          </Dialog>
          <Dialog
            :visible="deleteUsuarioEspecialidadDialog"
            :style="{ width: '450px' }"
            header="Confirmación de eliminación"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="usuarioEspecialidad"
                >Esta seguro que desea eliminar el el estudio
                <b>{{ usuarioEspecialidad.nombre }}</b
                >?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteUsuarioEspecialidadDialog = false"
                name="cancelar"
              />
              <Button
                label="Si"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteUsuarioEspecialidad"
                name="aceptar"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EspecialidadesService from "../service/especialidades.service";
import UsuariosEspecialidadesService from "../service/usuarios_especialidades.service";
import { mapGetters } from "vuex";
export default {
  metaInfo: {
    title: 'Backoffice - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Backoffice - QualityCare',
        content: 'Administración del sitio web',
      },
    ],
  },
  data() {
    return {
      especialidadesService: null,
      usuariosEspecialidadesService: null,
      filters: {},
      usuarioEspecialidad: {},
      usuariosEspecialidades: [],
      especialidades: [],
      usuarioEspecialidadDialog: false,
      deleteUsuarioEspecialidadDialog: false,
      submitted: false,
      nombreMedico: "",
      idMedico: "",
      loading: false,
      es: {
        firstDayOfWeek: 1,
        dayNames: [
          "Domingo",
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado",
        ],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        monthNamesShort: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ],
        today: "Hoy",
        clear: "Borrar",
        weekHeader: "Sm",
      },
    };
  },
  created() {
    this.especialidadesService = new EspecialidadesService();
    this.usuariosEspecialidadesService = new UsuariosEspecialidadesService();
  },
  mounted() {
    this.nombreMedico = `${this.getUsuario.nombres} ${this.getUsuario.apellidos}`;
    this.idMedico = this.getUsuario.id;
    this.recuperarEspecialidades();
    this.recuperarUsuarioEspecialidades();
  },
  methods: {
    recuperarUsuarioEspecialidades() {
      this.loading = true;
      this.usuariosEspecialidadesService
        .allEspecialidadesDeUnMedico(this.idMedico)
        .then((result) => {
          if (result.data.data) {
            this.usuariosEspecialidades = [...result.data.data];
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al cargar las especialidades del profesional",
            life: 3000,
          });
          this.loading = false;
        });
    },
    recuperarEspecialidades() {
      this.especialidadesService
        .allEspecialidades()
        .then((result) => {
          if (result.data.data) {
            this.especialidades = [...result.data.data];
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al cargar las especialidades",
            life: 3000,
          });
        });
    },
    openNew() {
      this.usuarioEspecialidad = {};
      this.submitted = false;
      this.usuarioEspecialidadDialog = true;
    },
    hideDialog() {
      this.usuarioEspecialidadDialog = false;
      this.submitted = false;
    },
    async saveUsuarioEspecialidad() {
      this.submitted = true;
      if (
        this.usuarioEspecialidad.id_especialidad &&
        this.usuarioEspecialidad.fecha_grado &&
        this.usuarioEspecialidad.universidad &&
        this.usuarioEspecialidad.titulo
      ) {
        if(!this.usuarioEspecialidad.descripcion) this.usuarioEspecialidad.descripcion=" ";
        if (this.usuarioEspecialidad.id) {
          //edicion de usuarioEspecialidad
          let idUsuarioEspecialidadEnEdicion = this.usuarioEspecialidad.id;
          let usuarioEspecialidadEditada = {};          
          let data = {
            id: this.usuarioEspecialidad.id,
            id_especialidad: this.usuarioEspecialidad.id_especialidad,
            fecha_grado: this.$moment(
              this.usuarioEspecialidad.fecha_grado
            ).format("YYYY-MM-DD"),
            universidad: this.usuarioEspecialidad.universidad,
            titulo: this.usuarioEspecialidad.titulo,
            descripcion: this.usuarioEspecialidad.descripcion,
            id_usuario: this.usuarioEspecialidad.id_usuario,
          };
          await this.usuariosEspecialidadesService
            .updateUsuarioEspecialidad(data)
            .then((result) => {
              usuarioEspecialidadEditada = result.data.data;
            })
            .catch((err) => {
              console.log(err);
            });
          this.$set(
            this.usuariosEspecialidades,
            this.findIndexById(idUsuarioEspecialidadEnEdicion),
            usuarioEspecialidadEditada
          );
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Relacion Usuario-Especialidad actualizada",
            life: 3000,
          });
        } else {
          //nueva usuario-Especialidad
          this.usuarioEspecialidad["id_usuario"] = this.idMedico;
          let data = {
            id_especialidad: this.usuarioEspecialidad.id_especialidad,
            fecha_grado: this.$moment(
              this.usuarioEspecialidad.fecha_grado
            ).format("YYYY-MM-DD"),
            universidad: this.usuarioEspecialidad.universidad,
            titulo: this.usuarioEspecialidad.titulo,
            descripcion: this.usuarioEspecialidad.descripcion,
            id_usuario: this.usuarioEspecialidad.id_usuario,
          };
          await this.usuariosEspecialidadesService
            .crearUsuarioEspecialidad(data)
            .then((result) => {
              this.usuariosEspecialidades.push(result.data.data);
              this.$toast.add({
                severity: "success",
                summary: "Felicidades",
                detail: "Relación Usuario-Especialidad creada",
                life: 3000,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
        this.usuarioEspecialidadDialog = false;
        this.usuarioEspecialidad = {};
      }
    },
    editUsuarioEspecialidad(usuarioEspecialidad) {
      this.usuarioEspecialidad = { ...usuarioEspecialidad };
      this.usuarioEspecialidadDialog = true;
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.usuariosEspecialidades.length; i++) {
        if (this.usuariosEspecialidades[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    confirmDeleteUsuarioEspecialidad(usuarioEspecialidad) {
      this.usuarioEspecialidad = usuarioEspecialidad;
      this.deleteUsuarioEspecialidadDialog = true;
    },
    deleteUsuarioEspecialidad() {
      this.usuariosEspecialidadesService
        .deleteUsuarioEspecialidad({
          id: this.usuarioEspecialidad.id,
        })
        .then(() => {
          this.usuariosEspecialidades = this.usuariosEspecialidades.filter(
            (val) => val.id !== this.usuarioEspecialidad.id
          );
          this.deleteUsuarioEspecialidadDialog = false;
          this.usuarioEspecialidad = {};
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Relación Usuario-Especialidad eliminada",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    ...mapGetters(["getUsuario"]),
  },
};
</script>

<style lang="scss" scoped>
.tituloUsuarios {
  font-size: 28px;
  font-weight: 400;
  margin-right: 50px;
}
.muyLargo {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.containerHeader {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #cfcfcf;
}
@media screen and (max-width: 40em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
        }
      }
    }
  }
}
</style>
